import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ReportRecipient } from '@app/interfaces/lm/report-schedules';
import { STColumn } from '@app/interfaces/sys/st';
import { ReportSchedulesService } from '@services/lm/report-schedules.service';
import { ReportingService } from '@services/lm/reporting.service';
import { AccountService } from '@services/sys/account.service';
import { AlertRecipients } from '@app/interfaces/am/alert';
import { Auth } from '@app/interfaces/sys/auth';

@Component({
    selector: 'app-email-recipients',
    templateUrl: './email-recipients.component.html',
    styleUrls: ['./email-recipients.component.less'],
})
export class EmailRecipientsComponent implements OnInit {
    @Input() title = 'Recipients';
    @Input() editData: string[] = [];
    @Input() id!: string;
    @Input() showLoading = false;
    columns: STColumn[] = [
        {
            type: 'selection',
            width: '50px'
        },
        {
            title: 'Name',
            index: 'username',
            width: '120px',
            // format: (item) => {
            //     return (item.name ? item.name : '') + ' ' + (item.lastName ? item.lastName : '');
            // },
        },
        {
            title: 'Email',
            index: 'email',
            width: '120px'
        },
    ];
    recipientList!: ReportRecipient[];
    fliterRecipientList!: ReportRecipient[];
    loading = false;
    validateForm!: FormGroup;
    listOfControl: any[] = [];
    selectUserEmails: string[] = [];
    autoTips: Record<string, Record<string, string>> = {
        default: {
            required: 'Input is required',
            email: 'The input is not valid email',
        },
    };
    filter: {
        keyword: string;
    } = {
        keyword: '',
    };
    currentUser!: Auth;

    constructor(private reportSchedulesService: ReportSchedulesService,
                private fb: FormBuilder,
                private accountService: AccountService,
                private reportingService: ReportingService) {
    }

    async ngOnInit(): Promise<void> {
        try {
            const info = localStorage.getItem('tokenData');
            this.currentUser = info ? JSON.parse(info) : null;
            this.listOfControl = [];
            this.recipientList = [];
            this.selectUserEmails = [];
            this.validateForm = this.fb.group({});
            this.loading = true;
            await this.getCandidateList();
            await this.fetchData(this.editData);
        } finally {
            this.loading = false;
        }
    }

    async getCandidateList(): Promise<void> {
        const query = {
            page: 0,
            size: 999999,
        };
        const { content } = await this.accountService.find(query);
        const userList = content || [];
        const filterUser = userList?.filter((item) => item.id.toString() !== this.currentUser.id.toString()) as any;
        const allrecipientList = [
            {
                ...this.currentUser,
                id: this.currentUser.id.toString(),
                // disabled: true
            },
            ...filterUser
        ];
        this.recipientList = allrecipientList;
        this.fliterRecipientList = allrecipientList;
    }

    fetchData(allArr: string[]): void {
        if (allArr && allArr.length > 0 && this.recipientList && this.recipientList.length > 0) {
            const emails = this.recipientList.map(item => item.email);
            const tableArr = allArr.filter((email: string) => emails.includes(email));
            const formArr = allArr.filter((email: string) => !emails.includes(email));
            this.selectUserEmails = tableArr;
            const fields: { [key: string]: string } = {};
            formArr?.forEach((item, index) => {
                const control: {
                    [key: string]: string | number
                } = {
                    index: index + 1,
                    email: `email${index + 1}`,
                };
                fields[control.email] = item;
                this.addControl(control);
            });
            this.validateForm.reset({
                ...fields,
            });
        } else {
            this.selectUserEmails = allArr || [];
        }
    }

    addField(e?: MouseEvent): void {
        if (e) {
            e.preventDefault();
        }
        const index = this.listOfControl.length > 0 ? this.listOfControl[this.listOfControl.length - 1].index + 1 : 1;

        const control = {
            index,
            email: `email${index}`
        };
        this.addControl(control);
    }

    addControl(control: { [key: string]: string | number }): void {
        const index = this.listOfControl.push(control);
        const needControl = JSON.parse(JSON.stringify(control));
        delete needControl.index;
        if (needControl.id) {
            delete needControl.id;
        }
        Object.keys(needControl).forEach((item) => {
            this.validateForm.addControl(
                this.listOfControl[index - 1][item],
                new FormControl(null, [Validators.required, Validators.email]),
            );
        });
    }

    handleSelect(ids: string[]): void {
        this.selectUserEmails = [...ids];
    }

    removeField(i: { index: number; email: string; }, e: MouseEvent): void {
        e.preventDefault();
        const index = this.listOfControl.indexOf(i);
        this.listOfControl.splice(index, 1);
        Object.values(i).forEach((fieldItem) => {
            this.validateForm.removeControl(fieldItem as string);
        });
    }

    validForm(): boolean {
        for (const control of Object.values(this.validateForm.controls)) {
            control.markAsDirty();
            control.updateValueAndValidity();
        }
        if (!this.validateForm.valid) {
            return false;
        }
        return true;
    }

    getParams(): AlertRecipients[] {
        const data = this.validateForm.value;
        const arr = this.listOfControl?.map((item) => {
            return data[item.email];
        });
        const selectTable = this.recipientList.filter(it => this.selectUserEmails.includes(it.email));
        const recipients: AlertRecipients[] = selectTable.map(it => {
            const { id, username, email } = it;
            return {
                userId: id,
                username,
                email
            };
        });
        console.log('getParams', arr, recipients, this.selectUserEmails);
        arr.forEach(x => {
            if (this.selectUserEmails.includes(x)) {
                return;
            }
            recipients.push({
                userId: '',
                username: '',
                email: x
            });
        });
        return recipients;
    }

    enterSearch(event: KeyboardEvent): void {
        if (event.key === 'Enter') {
            this.onSearch();
        }
    }

    onSearch(): void {
        this.fliterRecipientList = this.recipientList.filter((item) => {
            return item.username.toLowerCase().includes(this.filter.keyword.toLowerCase()) || item.email.toLowerCase().includes(this.filter.keyword.toLowerCase());
        });
    }

    clearKeyword(): void {
        this.filter.keyword = '';
        this.fliterRecipientList = this.recipientList;
    }

    onKeywordChange(): void {
        if (!this.filter.keyword) {
            this.clearKeyword();
        }
    }

}
